import { useId } from 'react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { isValidUrl } from '@/lib/buildUrl'

interface BaseUrlFieldProps {
  value: string
  onChange: (value: string) => void
  onLoad: () => void
  onFocus?: () => void
  onBlur?: () => void
  loadedValue: string
}

export function BaseUrlField({
  value,
  onChange,
  onLoad,
  onFocus,
  onBlur,
  loadedValue,
}: BaseUrlFieldProps) {
  const inputId = useId()
  const errorId = useId()
  const valid = isValidUrl(value)
  const showError = value.trim() !== '' && !valid
  const canLoad = valid && value !== loadedValue

  return (
    <form
      className="space-y-1.5"
      onSubmit={(e) => {
        e.preventDefault()
        if (canLoad) onLoad()
      }}
    >
      <Label htmlFor={inputId}>Page URL</Label>
      <div className="flex gap-2">
        <Input
          id={inputId}
          type="url"
          inputMode="url"
          spellCheck={false}
          autoComplete="off"
          placeholder="https://example.org/page"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onFocus={onFocus}
          onBlur={onBlur}
          aria-invalid={showError || undefined}
          aria-describedby={showError ? errorId : undefined}
        />
        <Button type="submit" disabled={!canLoad}>
          Go
        </Button>
      </div>
      {showError && (
        <p id={errorId} className="text-xs text-destructive">
          Enter a full URL including <code>https://</code>.
        </p>
      )}
    </form>
  )
}
